export const initInputStateSwitch = () => {
	const elements = Array.from(document.querySelectorAll(`.state-switch`));
	
	if ( elements )
	{
		elements.forEach((element) => element.checked ? element.checked = true : element.checked = false);
		// element.querySelector(`.state-switch:not([checked])`).checked = false;
		// element.querySelector(`.state-switch[checked]`).checked = true;
	}
	
	// add some function
	// etc.
};
